import React, { useEffect, useState } from 'react';
import Modal from 'components/Modal';
import DateDelivery from './DateDelivery';
import { actionsType } from 'config/constants';
import PubSub from 'services/PubSub/';
import NewRelicService from 'services/NewRelic'
import style from './style.scss';//NOSONAR


let actions = [];

const ModalDateDelivery = () => {

    const [value, setValue] = useState(null);

    useEffect(() => {
        actions.push(PubSub.register(actionsType.MODAL.DATE_DELIVERY_OPEN, _open));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, []);

    const _open = (payload) => {
        NewRelicService.sendPageAction({
            action: 'openModalDateDelivery'
        });
        setValue(payload.value);
    }
    return (
        <Modal customClass={'modal-date-delivery-content'} actionOpen={actionsType.MODAL.DATE_DELIVERY_OPEN} actionClose={actionsType.MODAL.DATE_DELIVERY_CLOSE} >
            <DateDelivery value={value}/>
        </Modal>
    )
}


export default ModalDateDelivery;
